import React, { useState } from "react";
import { MdBrokenImage } from "react-icons/md";

interface BlurredImageProps {
  src: string;
  alt: string;
  blurred: boolean;
  onClick?: () => void;
  // Size / shape of the image and of the fallback box that replaces it
  className?: string;
  // Tailwind blur strength while `blurred`; thumbnails need less than tiles
  blurClass?: string;
}

// A progress photo or measurement attachment: blurred until the viewer opts
// in (see BlurToggleButton), and swapped for a placeholder if the file fails
// to load so a dead link never leaves a broken-image glyph in the grid.
const BlurredImage: React.FC<BlurredImageProps> = ({
  src,
  alt,
  blurred,
  onClick,
  className = "",
  blurClass = "blur-lg",
}) => {
  const [broken, setBroken] = useState(false);

  if (broken) {
    return (
      <div
        className={`flex items-center justify-center bg-gray-100 dark:bg-navy-800 ${className}`}
        title="Image unavailable"
      >
        <MdBrokenImage className="h-5 w-5 text-gray-400" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onClick={onClick}
      onError={() => setBroken(true)}
      className={`object-cover transition-all duration-300 ${
        blurred ? blurClass : "blur-0"
      } ${className}`}
    />
  );
};

export default BlurredImage;
